// src/pages/CancelPage.js

import React from 'react'
import { useNavigate } from 'react-router-dom'

const CancelPage = () => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate('/game-user-pricing-table') // or wherever you want to take them
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-red-50 text-center">
      <h1 className="text-3xl font-bold text-red-600 mb-4">Payment Cancelled</h1>
      <p className="text-gray-700 mb-6">You have cancelled the payment. No money was deducted.</p>
      <button
        onClick={handleBack}
        className="px-6 py-2 text-white bg-red-500 rounded hover:bg-red-600"
      >
        Back to Pricing
      </button>
    </div>
  )
}

export default CancelPage
